module.exports = __webpack_public_path__ + "media/images/new/cell_coverage_maps_phone@2x-f3661fed98890244db0b2ac628679be5.png";